import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

import Box from "@mui/material/Box";
import DoneIcon from '@mui/icons-material/Done';
import GPAP_Button from '../../../../gpap-lib/Button_Collection';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


const ExperimentDeletionReport = (props) => {

    const { onClose, open, experiments } = props;

    return(
        <React.Fragment>
            <Dialog open={open}>
                <DialogTitle> <center> Experiments successfully deleted </center> </DialogTitle>

                <DialogContent>
                    <Box p={2}>
                        <TableContainer component={Paper} sx={{height:550}}>
                            <Table sx={{ minWidth: 450 }} size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Experiment ID</TableCell>
                                        <TableCell>Local Experiment ID</TableCell>
                                    </TableRow>
                                </TableHead>
                            <TableBody>
                                {experiments.map((row) => (
                                    <TableRow
                                        key={row[0]}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell> {row[0]} </TableCell>
                                        <TableCell> {row[1].LocalExperimentID} </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        </TableContainer> 
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Box p={1}>
                        <GPAP_Button id="validate"  onClick={onClose}  startIcon={<DoneIcon />}>
                            Close
                        </GPAP_Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

}

export default ExperimentDeletionReport;